<template lang="pug">
  .pagination
    .pagination__button
      button.pag-link(
        type="button"
      )
        img(src="@/assets/images/icons/pag-prev.svg")
    ul.pagination__list
      li.pagination__item
        a.pag-link.pag-link_active(
          href="#"
        ) 1
      li.pagination__item
        a.pag-link(
        href="#"
        ) 2
      li.pagination__item
        a.pag-link(
        href="#"
        ) 3
      li.pagination__item
        a.pag-link(
        href="#"
        ) 4
      li.pagination__item
        a.pag-link(
        href="#"
        ) 5
      li.pagination__item
        a.pag-link(
        href="#"
        ) 10
    .pagination__button
      button.pag-link(
        type="button"
      )
        img(src="@/assets/images/icons/pag-next.svg")
</template>

<script>
export default {
  name: "Pagination"
};
</script>
